export const VALIDATION_FAILURE_REDIRECT_EVENTACTION = 'Validatiefout - Redirect naar stap 1';
